var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 27940 21590",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_870258048"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M22326 15396l0 -125c-35,43 -23,-54 -25,52 -3,129 -2,38 25,73z",
    fill: "#C7DCE9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M22373 15772c5,-113 0,-50 -23,-74 0,103 4,51 23,74z",
    fill: "#9BC2DB"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M13957 16068c-47,0 -37,-13 -37,29 46,0 37,13 37,-29z",
    fill: "#2A2D2E"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M16950 16097c0,-42 10,-29 -37,-29 0,42 -9,29 37,29z",
    fill: "#2A2C2F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M17289 16018c-46,0 -37,-13 -37,29 46,0 37,13 37,-29z",
    fill: "#2A2C2F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M17189 16068c-46,0 -37,-12 -37,29 46,0 37,13 37,-29z",
    fill: "#2A2C2F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M6044 19179c-92,0 -35,-8 -54,26l54 -26z",
    fill: "#9BC2DB"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "26810,13817 26781,13792 ",
    fill: "#A6C5D8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil5",
    points: "26385,16223 26359,16247 ",
    fill: "#A9CCE3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "3960,2167 3936,2142 ",
    fill: "#9BC2DB"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "8244,2392 8217,2418 ",
    fill: "#9BC2DB"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil6",
    points: "17540,2917 17513,2944 ",
    fill: "#97C5E1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil5",
    points: "13279,18603 13255,18627 ",
    fill: "#A9CCE3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "9498,19104 9472,19128 ",
    fill: "#A6C5D8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "16613,2994 16587,2968 ",
    fill: "#9BC2DB"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil7",
    points: "22927,5499 22951,5445 ",
    fill: "#A7BBC7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil5",
    points: "21372,19304 21348,19278 ",
    fill: "#A9CCE3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "21474,19354 21448,19329 ",
    fill: "#A6C5D8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil5",
    points: "26760,13792 26733,13767 ",
    fill: "#A9CCE3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "14460,19730 14433,19704 ",
    fill: "#9BC2DB"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil8",
    d: "M4049 5000c199,0 362,163 362,362l0 10400c0,199 -163,362 -362,362 -199,0 -362,-163 -362,-362l0 -10400c0,-199 163,-362 362,-362zm12539 14605l0 0c176,-124 330,-271 450,-451 143,104 275,415 799,630 618,253 1155,253 1757,-29 418,-195 868,-710 977,-1177l345 382c305,307 769,525 1189,614 697,147 1564,110 2191,-228 349,-187 669,-527 844,-885 153,-313 331,-1002 365,-1365l440 0c977,0 1777,-800 1777,-1777l0 0c0,-862 -622,-1585 -1438,-1744l0 -960c1,-773 -706,-642 -702,-51l-16 978 -1111 0 0 -927c3,-751 -757,-729 -752,50l0 923c-786,182 -1377,891 -1377,1731l0 0c0,977 800,1777 1777,1777l652 0c-8,208 -131,692 -193,838 -234,549 -458,801 -1120,934 -549,110 -1234,52 -1736,-222 -716,-392 -1035,-1308 -1035,-2073l1 -9320c12,-779 -744,-615 -744,-71l-8 10619c0,406 -19,611 -186,866 -216,329 -581,550 -991,563 -588,18 -1107,-261 -1274,-882 -148,-549 121,-1179 -381,-1225 -584,-53 -368,718 -429,1101 -217,1376 -2483,1397 -2477,-298 1,-279 27,-510 -106,-670 -138,-168 -404,-189 -551,-12 -227,277 32,663 -185,1218 -313,799 -1324,1007 -1993,471 -72,-58 -168,-180 -222,-255 -343,-473 -40,-1212 -356,-1472 -275,-226 -609,11 -588,363 6,112 -7,327 -6,509 0,184 -55,327 -118,458 -367,765 -1412,927 -2019,324 -601,-597 -249,-1240 -403,-1527 -119,-220 -432,-295 -612,-77 -236,284 159,872 -378,1551 -274,347 -767,473 -1186,401 -654,-111 -1051,-647 -1048,-1306 0,-156 21,-469 -27,-575 -140,-305 -701,-272 -688,170 0,556 57,830 -312,1306 -449,581 -1448,554 -1901,-3 -193,-238 -306,-435 -304,-798 25,-4753 0,-9549 0,-14307 0,-777 300,-1450 1189,-1496 424,-22 858,171 1130,580 366,550 4,1058 498,1159 167,34 305,-70 370,-162 142,-199 -56,-407 178,-874 567,-1131 2372,-873 2397,594 11,665 747,582 734,17 -17,-724 522,-1252 1189,-1308 468,-39 885,172 1174,648 254,417 14,811 306,1023 152,112 356,84 472,-38 171,-180 91,-690 276,-1028 436,-793 1895,-919 2280,268 46,142 44,336 72,504 62,375 386,497 633,234 80,-85 111,-266 123,-436 86,-1231 1484,-1579 2205,-730 255,300 252,593 282,971 33,400 720,478 729,-49 9,-595 202,-1071 810,-1295 972,-358 1515,451 1703,1334 34,161 139,292 301,327 200,42 328,-75 396,-188 83,-138 41,-397 23,-558 -108,-983 -974,-1740 -1989,-1727 -995,13 -1348,549 -1622,802 -386,-599 -1073,-848 -1707,-834 -822,18 -1317,551 -1525,834 -252,-239 -545,-851 -1686,-802 -955,42 -1229,527 -1571,802 -304,-298 -753,-836 -1686,-804 -934,32 -1272,580 -1571,829 -262,-496 -1029,-830 -1591,-829 -1071,3 -1522,645 -1666,829 -316,-564 -1176,-858 -1695,-837 -661,26 -1150,348 -1530,844 -403,527 -357,990 -357,1772l0 13530c0,797 32,1146 447,1657 188,232 459,426 730,547 413,185 1014,205 1442,64 217,-72 401,-166 557,-295l431 -420c112,108 518,804 1604,802 399,-1 634,-48 977,-225 196,-102 583,-406 674,-577 107,153 377,556 1045,736 199,53 314,66 561,66 242,0 350,-5 545,-57 178,-48 463,-178 618,-283 114,-77 371,-322 465,-462l294 307c107,108 211,173 347,255 649,395 1773,303 2297,-230 86,-87 263,-214 294,-332 308,441 1557,1330 2807,451zm7525 -5337l0 0 1822 0c578,0 1051,473 1051,1051l0 0c0,578 -473,1050 -1051,1050l-1822 0c-578,0 -1051,-472 -1051,-1050l0 0c0,-578 473,-1051 1051,-1051zm-2691 -10425l0 0c814,0 1473,659 1473,1473 0,814 -659,1473 -1473,1473 -813,0 -1473,-659 -1473,-1473 0,-814 660,-1473 1473,-1473zm0 663l0 0c447,0 810,363 810,810 0,447 -363,810 -810,810 -447,0 -809,-363 -809,-810 0,-447 362,-810 809,-810zm-4373 481l0 0c200,0 363,163 363,362l0 10400c0,200 -163,363 -363,363 -199,0 -362,-163 -362,-363l0 -10400c0,-199 163,-362 362,-362zm-3243 1l0 0c199,0 362,163 362,362l0 10400c0,200 -163,363 -362,363 -199,0 -362,-163 -362,-363l0 -10400c0,-199 163,-362 362,-362zm-3257 8l0 0c200,0 363,163 363,362l0 10400c0,200 -163,363 -363,363 -199,0 -362,-163 -362,-363l0 -10400c0,-199 163,-362 362,-362zm-3244 -1l0 0c199,0 362,163 362,362l0 10400c0,199 -163,362 -362,362 -199,0 -362,-163 -362,-362l0 -10400c0,-199 163,-362 362,-362z",
    fill: "#808080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectric);
export default __webpack_public_path__ + "static/media/electric.691172cbc1de459c02c10c41d6972d56.svg";
export { ForwardRef as ReactComponent };